module.exports = __webpack_public_path__ + "img/index.e733f934.png";